/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import { useBlockProps } from '@wordpress/block-editor';

//console.log('view.js: ', useBlockProps);

function waitForElement(selector, callback, maxWaitTime = 10000) {
    const interval = setInterval(() => {
        //console.log("Waiting for element...");
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval); 
            clearTimeout(timeout); 
            callback(element); 
        }
    }, 50);

    const timeout = setTimeout(() => {
        //console.log("Element not found within the maximum wait time.");
        clearInterval(interval); 
    }, maxWaitTime);
}

waitForElement('.wis2-promocode__link', (targetElement) => {
    if (targetElement.textContent.includes("alennuskoodi")) {
        targetElement.textContent = "Lisää tarjouskoodi »";
    }
});